<template>
  <div class="loading-screen d-flex flex-column justify-content-center text-center">
    <div class="">
      <h1>Wanesy Management Center</h1>

      <h4 v-if="step===1" class="mt-4 mb-3">{{ $t('loading:loading') | capitalize }}</h4>
      <h4 v-if="step===2" class="mt-4 mb-3">{{ $t('loading:stillLoading') | capitalize }}</h4>
      <h4 v-if="step>2" class="mt-4 mb-3">{{ $t('loading:away') | capitalize }}</h4>

      <div class="spinner">
        <div class="double-bounce1" />
        <div class="double-bounce2" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      step: 1
    }
  },

  created () {
    setInterval(() => { this.step++ }, 20000)
  }
}
</script>

<style scoped lang="scss">
  .loading-screen {
    height: 100vh;
    margin-top: -50px;

    .spinner {
      position: relative;
      width: 30px;
      height: 30px;
      margin: 0 auto;
    }

    .double-bounce1,
    .double-bounce2 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #2e3955;
      border-radius: 50%;
      opacity: 0.6;
      animation: sk-bounce 2s infinite ease-in-out;
    }

    .double-bounce2 {
      animation-delay: -1s;
    }

    @keyframes sk-bounce {
      0%,
      100% {
        transform: scale(0);
      }

      50% {
        transform: scale(1);
      }
    }
  }
</style>
